import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function Flow() {
  return (
    <section className="flow-section" style={{ padding: "150px 0 60px" }}>
      <Container>
        <Row>
          <Col lg="10" className="mx-auto">
            <div className="flow-content text-center text-white">
              {/* <h2 className="d-flex justify-content-center section-title mb-5 align-items-center">
                Go With The Flow
                <span className="ml-2">
                  <StaticImage
                    className="img-fluid ml-2"
                    src="../../images/flow-logo.png"
                    alt="Logo"
                  />
                </span>
              </h2> */}
              <StaticImage
                className="img-fluid mb-5"
                src="../../images/flow-logo.png"
                alt="Logo"
              />
              <h3 className="mb-5 youthtouch">
                The art of living is to go with the flow. This is how we find
                true empowerment.
              </h3>
              <h5 className="youthtouch">#FeelAlive</h5>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
